import { Link } from 'react-router-dom'
import AuthLayout from './AuthLayout'
import CreateAccountForm from './CreateAccountForm'
import { signupEnabled } from '../../lib/businessAccessClient'

export default function RegisterPage() {
  return <AuthLayout>
    <p className="auth-eyebrow">LET’S GROW TOGETHER</p>
    <h1 className="auth-title">Get started with Wortelogy.</h1>
    <p className="auth-subtitle">A more connected business starts here.</p>
    {signupEnabled ? <CreateAccountForm /> : <><div className="auth-invitation">
      <span className="auth-badge">BUILDING WITH EARLY PARTNERS</span>
      <h2>A personal start for every business.</h2>
      <p>Meet our team, explore the system, and find the right setup for your business.</p>
      <a className="auth-btn auth-btn--primary" href="https://wortelogy.com/demo">Schedule a demo <span aria-hidden="true">↗</span></a>
    </div>
    <p className="auth-hint">Self-service signup is temporarily closed. Booking a demo does not create an account.</p></>}
    <p className="auth-footer">Already part of the team? <Link to="/login">Sign in</Link></p>
  </AuthLayout>
}
